import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { Login } from './components/Login';
import { Layout } from './components/Layout';
import { Loading } from './components/UI';

const page = (loader, name) => lazy(() => loader().then((module) => ({ default: module[name] })));
const DashboardPage = page(() => import('./pages/DashboardPage'), 'DashboardPage');
const SubnetsPage = page(() => import('./pages/SubnetsPage'), 'SubnetsPage');
const AttacksPage = page(() => import('./pages/AttacksPage'), 'AttacksPage');
const ScrubbersPage = page(() => import('./pages/ScrubbersPage'), 'ScrubbersPage');
const FilterTrafficPage = page(() => import('./pages/FilterTrafficPage'), 'FilterTrafficPage');
const ProfilesPage = page(() => import('./pages/ProfilesPage'), 'ProfilesPage');
const GuidePage = page(() => import('./pages/GuidePage'), 'GuidePage');
const APIReferencePage = page(() => import('./pages/APIReferencePage'), 'APIReferencePage');
const FirewallPage = page(() => import('./pages/FirewallPage'), 'FirewallPage');
const WhitelistPage = page(() => import('./pages/WhitelistPage'), 'WhitelistPage');
const UsersPage = page(() => import('./pages/UsersPage'), 'UsersPage');
const AuditPage = page(() => import('./pages/AuditPage'), 'AuditPage');
const GlobalConfigPage = page(() => import('./pages/GlobalConfigPage'), 'GlobalConfigPage');
const ServiceProbesPage = page(() => import('./pages/ServiceProbesPage'), 'ServiceProbesPage');

function Protected({ admin = false, children }) {
  const { authenticated, isAdmin } = useAuth();
  if (!authenticated) return <Navigate to="/app/login" replace />;
  if (admin && !isAdmin) return <Navigate to="/app" replace />;
  return children;
}

export function App() {
  return <Suspense fallback={<div className="route-loading"><Loading label="Loading page..." /></div>}><Routes>
    <Route path="/app/login" element={<Login />} />
    <Route path="/app" element={<Protected><Layout /></Protected>}>
      <Route index element={<DashboardPage />} />
      <Route path="subnets" element={<SubnetsPage />} />
      <Route path="attacks" element={<AttacksPage />} />
      <Route path="profiles" element={<ProfilesPage />} />
      <Route path="guide" element={<GuidePage />} />
      <Route path="api-reference" element={<APIReferencePage />} />
      <Route path="scrubbers" element={<Protected admin><ScrubbersPage /></Protected>} />
      <Route path="filter-traffic" element={<Protected admin><FilterTrafficPage /></Protected>} />
      <Route path="firewall" element={<Protected admin><FirewallPage /></Protected>} />
      <Route path="whitelist" element={<Protected admin><WhitelistPage /></Protected>} />
      <Route path="users" element={<Protected admin><UsersPage /></Protected>} />
      <Route path="audit" element={<Protected admin><AuditPage /></Protected>} />
      <Route path="global-config" element={<Protected admin><GlobalConfigPage /></Protected>} />
      <Route path="service-probes" element={<Protected admin><ServiceProbesPage /></Protected>} />
    </Route>
    <Route path="*" element={<Navigate to="/app" replace />} />
  </Routes></Suspense>;
}
